import '@fortawesome/fontawesome-free/css/all.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: '#1976d2',
                secondary: '#0A2463',
                third: '#48A9A6'
            }
        }
    },
    icons: {
        iconfont: 'fa'
    },
});